module.exports = __webpack_public_path__ + "static/media/39_slab marble breciia aurora texture-seamless.2771765f.jpg";